import React from 'react';
import { Box, Typography, Container, Paper, Link } from '@mui/material';
import { Helmet } from 'react-helmet';

const PrivacyPolicy = () => {
  return (
    <Box>
      <Helmet>
        <title>Privacy Policy - HawkClient</title>
        <meta
          name="description"
          content="Review HawkClient’s privacy policy regarding data collection and user information."
        />
      </Helmet>

      <Container maxWidth="sm" sx={{ mt: 6 }}>
        <Paper elevation={3} sx={{ p: 4, borderRadius: 2 }}>
          <Typography variant="h4" gutterBottom>
            Privacy Policy
          </Typography>

          <Typography variant="body1" paragraph>
            At HawkClient, we take user privacy seriously. This policy outlines what data is (and isn’t) collected during your use of the application.
          </Typography>

          <Typography variant="body1" paragraph>
            1. <strong>No Sign-In Required:</strong> HawkClient does not require users to sign in or create an account to use the application.
          </Typography>

          <Typography variant="body1" paragraph>
            2. <strong>Local Data Storage:</strong> All collections and related data are stored locally on your device’s file system. HawkClient does not store or sync any data to the cloud.
          </Typography>

          <Typography variant="body1" paragraph>
            3. <strong>Minimal Usage Analytics:</strong> HawkClient may collect basic anonymous telemetry such as application ID, version number, and operating system type. This is used solely to understand the distribution of installations across platforms and improve future releases. No personally identifiable information (PII) is collected.
          </Typography>

          <Typography variant="body1" paragraph>
            By using HawkClient, you agree to the terms outlined in this privacy policy.
          </Typography>

          <Typography variant="body1" paragraph>
            For any questions or concerns, please contact:{' '}
            <Link href="mailto:support@hawkclient.com" underline="hover">
              support@hawkclient.com
            </Link>
          </Typography>
        </Paper>
      </Container>
    </Box>
  );
};

export default PrivacyPolicy;
